import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from "@material-ui/core"

const InputWithComaView = ({ value, onChange, min, max, label }) => {
    const [internalValue, setInternalValue] = useState(value || '');

    const formatNumberWithCommas = (num) => {
        return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

  const handleChange = (e) => {
    let rawValue = e.target.value.replace(/,/g, '');

    let [integerPart, decimalPart] = rawValue.split('.');

    if (decimalPart && decimalPart.length > 2) {
      decimalPart = decimalPart.slice(0, 2);
    }

    let formattedValue = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    if (isNaN(formattedValue)) return;

    const numericValue = Number(formattedValue);

    if ((max && numericValue > max) || (min && numericValue < min)) {
      return;
    }

    setInternalValue(formattedValue);
    onChange(formattedValue);
  };

    return (
      <div className='fieldContainer'>
          <TextField
            label={label || 'Amount'}
            variant="filled"
            fullWidth
            value={formatNumberWithCommas(internalValue)}
            onChange={handleChange}
            inputProps={{
                min: min,
                max: max,
            }}
          />
      </div>
    );
};

InputWithComaView.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
};

export default InputWithComaView;